import {Internal} from '../Internal';
import {BaseInterface} from '../BaseInterface';

export class Factory {

    // ########################################

    public create(errors: BaseInterface[]): Internal {
        return new Internal(
            errors
        );
    }

    // ########################################
}
